import React from 'react';
import {useDispatch} from 'react-redux';
import {layoutActions} from '..';
import {IDialogProps} from '../types';

export function useOpenSubDialogCb() {
   const dispatch = useDispatch();

   return React.useCallback(
      function <T>(
         id: string,
         data?: T,
         title?: string,
         content?: string,
         onClose?: IDialogProps['onClose']
      ) {
         dispatch(
            layoutActions.openSubDialog({
               id,
               data,
               title,
               content,
               onClose,
            })
         );
      },
      [dispatch]
   );
}
